import { useEffect } from 'react';

import { useHistory, useRouteMatch } from 'react-router';

const InsurerDetailsPage = () => {
  const history = useHistory();
  const match = useRouteMatch<{ insurerId: string }>();
  const { insurerId } = match.params;

  useEffect(() => {
    if (match.isExact) {
      history.push(`/app/registry/insurers/${insurerId}/general`);
    }
  }, [match]);

  return null;
};

export default InsurerDetailsPage;
